import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addCandidateNote,
  deleteCandidateNote,
  getCandidateDetails,
  getCandidateNoteList,
  updateCandidateNote,
  updateMediaLinks,
} from "api/candidate.api";

import { notificationController } from "controllers/notificationController";

export interface CandidateSlice {
  candidate_details: any;
  candidate_details_loading_status: number;
  candidate_note_list: any;
}

const initialState: CandidateSlice = {
  candidate_details: null,
  candidate_details_loading_status: 0,
  candidate_note_list: null,
};

export const doGetCandidateNoteList = createAsyncThunk(
  "candidate/doGetCandidateNoteList",
  async (candidateId: number) =>
    getCandidateNoteList(candidateId).then((res: any) => {
      return res;
    })
);

export const doDeleteCandidateNote = createAsyncThunk(
  "candidate/doDeleteCandidateNote",
  async (args: any, { dispatch }) => {
    deleteCandidateNote(args.id, args.candidateId).then(
      (res) => {
        //   dispatch(doGetCandidateNoteList(args.candidateId));
        dispatch(doGetCandidateDetails(args.candidateId));
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);
export const doAddCandidateNote = createAsyncThunk(
  "candidate/doAddCandidateNote",
  async (pipelinePayload: { note: string; candidate: number }, { dispatch }) =>
    addCandidateNote(pipelinePayload).then((res) => {
      // dispatch(doGetCandidateNoteList(pipelinePayload.candidate));
      dispatch(doGetCandidateDetails(pipelinePayload.candidate));
      return res;
    })
);

export const doUpdateCandidateNote = createAsyncThunk(
  "candidate/doUpdatePipeline",
  async (
    pipelinePayload: { id: number; note: string; candidate: number },
    { dispatch }
  ) =>
    updateCandidateNote(pipelinePayload.id, pipelinePayload).then((res) => {
      //dispatch(doGetCandidateNoteList(pipelinePayload.candidate));
      dispatch(doGetCandidateDetails(pipelinePayload.candidate));
      return res;
    })
);

export const doGetCandidateDetails = createAsyncThunk(
  "candidate/doGetCandidateDetails",
  async (candidateId: number) =>
    getCandidateDetails(candidateId).then((res: any) => {
      return res;
    })
);

export const doUpdateMediaLink = createAsyncThunk(
  "candidate/doUpdateMediaLink",
  async (payload: any, { dispatch }) =>
    updateMediaLinks(payload).then((res: any) => {
      dispatch(doGetCandidateDetails(payload.candidate));
      return res;
    })
);

const candidateSlice = createSlice({
  name: "candidate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetCandidateDetails.pending, (state, action) => {
      state.candidate_details_loading_status = 1;
    });
    builder.addCase(doGetCandidateDetails.fulfilled, (state, action) => {
      state.candidate_details = action.payload;
      state.candidate_details_loading_status = 2;
    });
    builder.addCase(doGetCandidateNoteList.fulfilled, (state, action) => {
      state.candidate_note_list = action.payload;
    });
  },
});

export default candidateSlice.reducer;
